import { Modal, toast } from '@solinkcorp/solink-components';
import { type AiNotification, type ScheduledActivityEntity } from 'clients/CallhomeApiTypes';
import useAiNotifications from 'components/SpotCheckPanel/hooks/useAiNotifcations';
import { useSpotChecks } from 'components/SpotCheckPanel/hooks/useSpotChecks';
import useLocale from 'src/hooks/useLocale';
import { useSelector } from 'stores/store';
import LocaleUtil from 'utils/LocaleUtil';

interface SpotCheckDeleteConfirmationModalProps {
  isModalOpen: boolean;
  closeModal: () => void;
  openModal: () => void;
  spotCheck: ScheduledActivityEntity | undefined;
  eventSpotCheck: AiNotification | undefined;
}

export default function SpotCheckDeleteConfirmationModal(
  props: SpotCheckDeleteConfirmationModalProps,
) {
  const { isModalOpen, closeModal, spotCheck, eventSpotCheck } = props;
  const locale = useLocale();

  const { spotCheckMode } = useSelector((state) => ({
    spotCheckMode: state.filter.spotCheckMode,
  }));

  const isEventSpotCheck = spotCheckMode === 'event';

  const text = LocaleUtil.getLocalizedStr({
    string: locale.general.deleteConfirmMessage,
    replacements: {
      name: isEventSpotCheck
        ? (eventSpotCheck?.metadata?.title ?? locale.scheduledAIChat.eventSpotCheck)
        : spotCheck?.title,
    },
  });

  const spotChecks = useSpotChecks();

  const handleDeleteSpotCheck = () => {
    try {
      if (!spotCheck) return;
      spotChecks.turnOffScheduledActivity(spotCheck.id);
      toast.success(locale.scheduledAIChat.successDeleteSpotCheck);
      closeModal();
    } catch (_error) {
      toast.error(locale.scheduledAIChat.failedToDeleteSpotCheck);
    }
  };

  const eventSpotChecks = useAiNotifications();
  const handleDeleteEventSpotCheck = async () => {
    try {
      if (!eventSpotCheck?.id) return;
      await eventSpotChecks.deleteAiNotification(eventSpotCheck.id);
      toast.success(locale.scheduledAIChat.successDeleteSpotCheck);
      closeModal();
    } catch (_error) {
      toast.error(locale.scheduledAIChat.failedToDeleteSpotCheck);
    }
  };

  const modalActions = [
    {
      isPrimary: false,
      text: locale.general.cancel,
      onClick: closeModal,
    },
    {
      isPrimary: true,
      text: locale.general.delete,
      onClick: isEventSpotCheck ? handleDeleteEventSpotCheck : handleDeleteSpotCheck,
    },
  ];

  return (
    <Modal
      actions={modalActions}
      title={locale.scheduledAIChat.deleteSpotCheck}
      isOpen={isModalOpen}
      onClose={closeModal}
    >
      <div>{text}</div>
    </Modal>
  );
}
